import { Component, inject } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { HeaderComponent } from '../../atoms/header/header.component';
import { InputTextModule } from 'primeng/inputtext';
import { NgIf } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { BaseListComponent } from '../../organisms/base-list/base-list.component';
import { TableListActionsComponent } from '../table-list-actions/table-list-actions.component';
import { TableCaptionComponent } from '../table-list-caption/table-list-caption.component';
import { MaskComponent } from '../../organisms/mask/mask.component';
import { RoleStore } from '../../../stores/role/role.state';
import { Role } from '../../../models/rbac';
import { RoutingService } from '../../../services/routing.service';

@Component({
  selector: 'app-role-list',
  standalone: true,
  imports: [
    CardModule,
    ButtonModule,
    HeaderComponent,
    InputTextModule,
    NgIf,
    PaginatorModule,
    RouterOutlet,
    SidebarModule,
    TabMenuModule,
    TableModule,
    ToastModule,
    TableListActionsComponent,
    TableCaptionComponent,
    MaskComponent,
  ],
  templateUrl: './role-list.component.html',
  styleUrl: './role-list.component.scss',
})
export class RoleListComponent extends BaseListComponent<Role> {
  readonly store = inject(RoleStore);
  override sidebarId = 'role-administration';

  constructor(
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );

    this.store.loadAllItemsByPromise();
  }
}
